import { get, post } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL; //"http://kube-w1:32751/api";

export function getKnockoutCriteria(partnerId) {
  return get(`${url}/leasingdocument/${partnerId}/knockout-criteria`);
}

export function evaluateKnockoutCriteria(documentId, siteId, partnerId) {
  return post(`${url}/leasingdocument/${documentId}/${siteId}/partner/${partnerId}/evaluate-knockout-criteria`, {
    documentId,
    siteId,
    partnerId
  });
}
